/**
 * lib/invitationAccept.js — Phase 0.7.1 invitation acceptance client.
 *
 * Single-route delegate to the additive shim at
 * `POST /api/employer/v1/invitations/accept`.
 * The shim validates the JWT, derives `accepting_uid` server-side,
 * and forwards to the LOCKED-LIVE `emp_member_invitation_accept`
 * RPC. Email-match is enforced inside the RPC (auth.users.email
 * vs. invitation.target_email).
 */
import { apiFetch } from '@/lib/api';

export function acceptInvitation({ token }) {
  return apiFetch('/api/employer/v1/invitations/accept', {
    method: 'POST',
    body:   { token },
  });
}
